import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class BusinessUnitStatusOrganization extends Model {
  @Expose()
  averageCustomerCost: number;

  @Expose()
  receiversCount: number;

  @Expose()
  customerCost: number;

  @Expose()
  customerId: number;

  @Expose()
  customerTitle: string;
}
